import { useEffect, useState, useRef } from "react";
import { constant } from "../constant/constantValue";
import { useTranslation } from "react-i18next";

const useResendOtp = (textRef) => {
  const [canResend, setCanResend] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(constant.RESEND_OTP_INTERVAL);
  const intervalRef = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    if (minutes === 0 && seconds === 0) {
      setCanResend(true); // Timer is done, allow resend
      return;
    }

    if (intervalRef.current) return; // Prevent setting multiple intervals

    // Start interval if no existing one
    intervalRef.current = setInterval(() => {
      if (seconds > 0) {
        setSeconds((prev) => prev - 1); // Decrease seconds
      } else if (minutes > 0) {
        setMinutes((prev) => prev - 1); // Decrease minutes
        setSeconds(59); // Reset seconds to 59
      } else {
        setCanResend(true); // Timer finished
        clearInterval(intervalRef.current); // Stop the interval
        intervalRef.current = null; // Clear interval reference
      }
    }, 1000);

    // Cleanup interval on unmount or if timer finishes
    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [minutes, seconds]);

  useEffect(() => {
    if (textRef.current) {
      textRef.current.innerHTML =
        minutes > 0 || seconds > 0
          ? `${t("OTP_SCREEN.resend-otp")} ${minutes}:${seconds
              .toString()
              .padStart(2, "0")}`
          : "";
    }
  }, [minutes, seconds, textRef]); // Update textRef when timer changes

  const resetTimer = () => {
    setMinutes(0);
    setSeconds(constant.RESEND_OTP_INTERVAL);
    setCanResend(false);
    clearInterval(intervalRef.current); // Stop previous interval
    intervalRef.current = null; // Clear reference
  };

  return { canResend, resetTimer };
};

export default useResendOtp;
